import { MimaButton, MimaText, Modal } from "../../components";
import React from "react";

const DeleteBroadcast = ({
  closeModal,
  onDelete,
  loading,
  selectedBroadcast,
}) => {
  return (
    <Modal closeModal={closeModal} goBack={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb={3}>
        Delete Broadcast
      </MimaText>

      <MimaText mb={2} align="center" width={40}>
        Are you sure you want to delete Broadcast with Title{" "}
        <span style={{ fontWeight: "700", color: "var(--color-primary)" }}>
          {selectedBroadcast.title}
        </span>{" "}
        ?
      </MimaText>

      <div className="modal__beside">
        <MimaButton
          title={"Yes"}
          width={18}
          onClick={() => onDelete(selectedBroadcast._id)}
          loading={loading}
        />

        <MimaButton
          title="Cancel"
          width={18}
          buttonColor="grey"
          onClick={() => closeModal()}
        />
      </div>
    </Modal>
  );
};

export default DeleteBroadcast;
